import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 23 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 26\" id=\"bell\"><path fill=\"none\" stroke=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M18.5 8.2c0-3.976-3.134-7.2-7-7.2s-7 3.224-7 7.2C4.5 16.6 1 19 1 19h21s-3.5-2.4-3.5-10.8m-4.982 15.6a2.322 2.322 0 0 1-2.018 1.196c-.832 0-1.6-.456-2.018-1.196\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol